<app-homepage-header pageName="Cart"></app-homepage-header>

<div class="w-100 h-100 mt-100px shipping-main">
  <div class="shipping-roadmap shr-top">
    <span class="shr-one">{{ 'shipping-address.cart' | translate }}</span>
    <span class="shr-two">/</span>
    <span class="shr-tree">{{ 'shipping-address.shipping' | translate }}</span>
  </div>
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="central-frame w-100 h-100 justify-content-center">
      <app-order-summary [allCarts]="products" [totalSumUsd]="totalSumUsd" [totalSumAmd]="totalSumAmd"
                         class="w-100 non-visible-os under-orders-part"></app-order-summary>
      <div class="shipping-roadmap non-visible-os shr-bottom">
        <span class="shr-one">{{ 'shipping-address.cart' | translate }}</span>
        <span class="shr-two">/</span>
        <span class="shr-tree">{{ 'shipping-address.shipping' | translate }}</span>
      </div>
      <div class="shipping-address">
        <div class="sha-top w-100 ">
          <h2 class="sha-top-title"> {{ 'shipping-address.shipping_address' | translate}} </h2>
          @if (selectedDeliveryMethod) {
            <div class="sha-ship-card mb-20px">
              <div class="flex-direction-column">
                <span class="sha-ship-card-title">{{ 'shipping-method.shipping_method' | translate }}</span>
                <span class="sha-ship-card-subtitle">{{ getShippingMethodName() | translate }}</span>
              </div>
              <button class="text-button tall-button" (click)="returnToShippingMethod()">{{ 'shipping-method.change' | translate }}</button>
            </div>
          }
          <div class="sha-form w-100">
            <mat-form-field appearance="fill" class="w-100 change-hover-size">
              <mat-label> {{ 'shipping-address.country_region' | translate}}</mat-label>
              <mat-select formControlName="country">
                @for (country of countries; track country) {
                  <mat-option [value]="country">
                    {{ country }}
                  </mat-option>
                }
              </mat-select>
              @if (contactForm.get('country')?.hasError('required') && contactForm.get('country')?.touched){
                <mat-error>
                  {{ 'shipping-address.country_region_required' | translate}}
                </mat-error>
              }
            </mat-form-field>


            <mat-form-field appearance="fill" class="w-100">
              <mat-label> {{ 'shipping-address.address' | translate}}</mat-label>
              <input matInput formControlName="address">
              @if (contactForm.get('address')?.invalid && (contactForm.get('address')?.dirty || contactForm.get('address')?.touched)) {
                  <mat-error>
                    {{ 'shipping-address.address_required_exceed' | translate}}
                  </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-100">
              <mat-label>{{ 'shipping-address.apartment_suite_optional' | translate}}</mat-label>
              <input matInput formControlName="apartment">
              @if (contactForm.get('apartment')?.invalid && contactForm.get('apartment')?.touched) {
                <mat-error>
                  {{ 'shipping-address.apartment_exceed' | translate}}
                </mat-error>
              }
            </mat-form-field>

            <div class="sha-form-row w-100">
              <mat-form-field appearance="fill" class="width-49 half-input">
                <mat-label>{{ 'shipping-address.postal_code' | translate}}</mat-label>
                <input matInput formControlName="postalCode">
                @if (contactForm.get('postalCode')?.invalid && contactForm.get('postalCode')?.touched) {
                  <mat-error style="line-height: normal">
                    {{ 'shipping-address.postal_code_required_alphanumeric' | translate}}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill" class="width-49 half-input">
                <mat-label>{{ 'shipping-address.city' | translate}}</mat-label>
                <input matInput formControlName="city">
                @if (contactForm.get('city')?.invalid && contactForm.get('city')?.touched) {
                  <mat-error style="line-height: normal">
                    {{ 'shipping-address.city_required_exceed' | translate}}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="mt-3 d-flex align-items-center ms-1">
              <input type="checkbox" id="check-24" formControlName="rememberAddress"/>
              <span class="checkbox-span ms-3">{{ 'shipping-address.save_address' | translate}}</span>
            </div>
          </div>
        </div>

        <div class="sha-bottom ">
          <button class="sha-bottom-visible sha-bottom-none-visible">
            {{ 'shipping-address.continue_to_shipping' | translate}}
          </button>
          <button class="sha-bottom-non-visible h-100" (click)="returnToShippingMethod()">
            {{ 'shipping-address.return_to_shipping_method' | translate}}
          </button>
          <button (click)="saveAddress()"
            class="sha-bottom-visible visible-get-os"
            type="submit">
            {{ 'shipping-address.continue_to_shipping' | translate}}
          </button>
        </div>
      </div>
      <app-order-summary [allCarts]="products" [totalSumUsd]="totalSumUsd" [totalSumAmd]="totalSumAmd"
                         class="w-100 right-orders-part"></app-order-summary>
    </div>
  </form>
</div>

<app-footer></app-footer>
